import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_THESEUS_URL,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    // ADD SOME GENERIC ONES HERE MAYBE?
  }),
})
